import { render } from "./RichContent.vue?vue&type=template&id=3030d17a&scoped=true"
import script from "./RichContent.vue?vue&type=script&lang=js"
export * from "./RichContent.vue?vue&type=script&lang=js"

import "./RichContent.vue?vue&type=style&index=0&id=3030d17a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3030d17a"]])

export default __exports__